<template>
  <div
    class="user-followers"
  >
    Followed by
    <a
      v-for="(key, name, index) in featuredFollowers"
      :key="name"
      :href="getFollowerProfileUrl(key)"
    >
      {{ getFollowerName(name, index) }}
    </a>
    <template v-if="followersAmount > 0">
      and {{ followersAmount }} other people you follow.
    </template>
  </div>
</template>

<script>
import URLS from '@d-shared/urls/urls';

export default {
  props: {
    featuredFollowers: {
      type: Object,
      required: true,
    },
    followersAmount: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    getFollowerName(name, index) {
      return this.isLastFeaturedFollower(index) ? name : `${name},`;
    },
    getFollowerProfileUrl(username) {
      return URLS.app.userProfile.entry.replace('<username>', username);
    },
    isLastFeaturedFollower(index) {
      return index === Object.keys(this.featuredFollowers).length - 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.user-followers {
  border-top: $border-width-base solid getColor($grey, base);
  color: getColor($grey, dark);
  padding: $_1em 0;
}
</style>
